import { h } from 'preact';
import * as BaseComp from 'components/bolt/videos/player.js';
// import s from 'components/bolt/videos/player.sss';
import Youtube from 'components/bolt/youtube/youtube';
import Vimeo from 'components/bolt/vimeo/vimeo';
import NativeVideo from 'components/bolt/nativeVideo/nativeVideo';
import Matterhorn from 'components/bolt/matterhorn/matterhorn';

export default class Player extends BaseComp.default {
	renderVideo() {
		const {
			activeVideo,
			onEnded, onStart, onPlay, onPause,
			overrideStyles,
			noAutoplay, muted,
			isShowtimesMessage,
			isTrailerOverlay,
			ageGateProtected
		} = this.props;

		if (!activeVideo) {
			return null;
		}

		const autoplay = !(noAutoplay || activeVideo.noAutoplay || ageGateProtected);
		if (activeVideo.youtubeId) {
			return (
				<Youtube
					ref={ref => this.player = ref}
					videoId={activeVideo.youtubeId}
					onEnded={onEnded}
					onStart={onStart}
					onPlay={onPlay}
					onPause={onPause}
					onPlayerReady={this.onReady}
					autoplay={autoplay}
					isShowtimesMessage={isShowtimesMessage}
					noCookies={activeVideo.noCookies && activeVideo.noCookies !== 'Cookie Mode'}
					disableCookieCheck={this.disableYoutubeCookieCheck}
					isTrailerOverlay={isTrailerOverlay}
					isTrailer={activeVideo.isTrailer}
					key={`youtube-${activeVideo.youtubeId}`}
					muted={muted}
					activePage={this.props.activePage}
				/>
			);
		}
		if (activeVideo.vimeoId) {
			return (
				<Vimeo
					ref={ref => this.player = ref}
					videoId={activeVideo.vimeoId}
					videoHash={activeVideo.vimeoHash}
					autoplay={autoplay}
					onEnded={onEnded}
					onPlayerReady={this.onReady}
					isShowtimesMessage={isShowtimesMessage}
					isTrailerOverlay={isTrailerOverlay}
					isTrailer={activeVideo.isTrailer}
					key={`vimeo-${activeVideo.vimeoId}`}
					muted={muted}
				/>
			);
		}
		if (activeVideo.videoSrc) {
			return (
				<NativeVideo
					ref={ref => this.player = ref}
					activeVideo={activeVideo}
					autoplay={autoplay}
					onEnded={onEnded}
					canPlayCallback={this.onReady}
					isShowtimesMessage={isShowtimesMessage}
					isTrailerOverlay={isTrailerOverlay}
					isTrailer={activeVideo.isTrailer}
					key={`nativeVideo-${activeVideo.videoSrc}`}
					overrideStyles={overrideStyles}
					muted={muted}
					useTracking
					pageId={this.props.pageId}
				/>
			);
		} else if (activeVideo.disneySrc) {
			return (
				<Matterhorn
					ref={ref => this.player = ref}
					activeVideo={activeVideo}
					autoplay={autoplay}
					isShowtimesMessage={isShowtimesMessage}
					isTrailerOverlay={isTrailerOverlay}
					isTrailer={activeVideo.isTrailer}
					onPlayerReady={this.onReady}
					key={`matterhorn-${activeVideo.disneySrc}`}
					muted={muted}
				/>
			);
		}
	}


}
